export default __webpack_public_path__ + "static/media/notFound.8839f1c3.png";